export default {
  // Navigation
  'nav.about': 'About',
  'nav.services': 'Services',
  'nav.team': 'Team',
  'nav.investment': 'Investment',
  'nav.contact': 'Contact',
  'nav.careers': 'Careers',
  'nav.getStarted': 'Get Started',

  // Careers page
  'careers.badge': 'We’re hiring',
  'careers.heroTitle': 'We Build Real Products, Not Just Ideas',
  'careers.heroSubtitle':
    'Flexy Group builds modern software, platforms, and infrastructure for teams that want to move fast—without sacrificing quality. Explore our open roles and grow with us.',
  'careers.heroCta': 'See open roles',
  'careers.heroSecondaryCta': 'Contact talent team',
  'careers.openRolesTitle': 'Open roles',
  'careers.openRolesSubtitle': 'Tap a role to read the full description and how to apply.',
  'careers.viewRole': 'View full description',
  'careers.backToCareers': 'All careers',
  'careers.jobNotFound': 'This job listing is no longer available.',
  'careers.jobSeniorCyclos.cardExcerpt':
    'Senior Cyclos developer for our digital payments and online banking platform—AWS, integrations, security, and mentoring. On site in LaSalle, Montréal. CAD 95,000/year.',
  'careers.statusActive': 'Active',
  'careers.postedOn': 'Posted on {{date}}',
  'careers.applyCta': 'Apply by email',
  'careers.detail.location': 'Location',
  'careers.detail.employment': 'Employment',
  'careers.detail.workArrangement': 'Work arrangement',
  'careers.detail.hours': 'Hours',
  'careers.detail.salary': 'Base salary',
  'careers.detail.vacancies': 'Vacancies',
  'careers.detail.startDate': 'Start date',
  'careers.detail.language': 'Language',

  // Common
  'common.learnMore': 'Learn More',
  'common.readMore': 'Read More',
  'common.getStarted': 'Get Started',
  'common.contactUs': 'Contact Us',
  'common.viewMore': 'View More',
  'common.connect': 'Connect',
  'common.copyright': '© Flexy Group, Inc.',
  'common.poweredBy': 'Powered by Readdy',

  // Footer
  'footer.description': 'Powering Growth through Technology and Strategic Investment. We specialize in digital payment solutions, banking software, and strategic tech investments.',
  'footer.sections': 'Sections',
  'footer.services': 'Services',
  'footer.aboutUs': 'About Us',
  'footer.digitalPayments': 'Digital Payment Solutions',
  'footer.bankingSoftware': 'Banking Software',
  'footer.customDevelopment': 'Custom Software Development',
  'footer.strategicInvestment': 'Strategic Tech Investment',
  'footer.cyclosSupport': 'Cyclos Support',
};
